import React from "react";
import { store } from "@store";
import locale from "@bonliva-crm/locale";

type Props = {
  children: React.ReactNode;
  blockId: string;
  dirty?: boolean;
  ignoreHashChanges?: boolean;
  message?: string;
};

export class WithRouteBlock extends React.Component<Props> {
  static defaultProps: Partial<Props> = {
    message: locale.ConfirmLeaveText
  };

  componentDidUpdate(prevProps: Props) {
    if (!prevProps.dirty && this.props.dirty) {
      store().ui.blockHistory(
        this.props.blockId,
        this.props.message,
        this.props.ignoreHashChanges
      );
    } else if (prevProps.dirty && !this.props.dirty) {
      store().ui.unblockHistory(this.props.blockId);
    }
  }

  componentWillUnmount() {
    store().ui.unblockHistory(this.props.blockId);
  }

  render() {
    return this.props.children;
  }
}

export default WithRouteBlock;
